import styled from "@emotion/styled";
import Typography from "@mui/material/Typography";

export const DataLabel = styled(Typography)`
  font-family: Montserrat;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.2;
  color: #A3A3A3;
`;
export const DataValue = styled(Typography)`
  font-family: Montserrat;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.2;
  color: #000;
`;
